import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Divider } from 'ui-components/components/divider';
import { FlexColumn } from 'ui-components/components/flex';

import style from './shipment-details-grid-layout.module.less';

export const ShipmentDetailsGridLayout = ({
  className,
  addressColumnContent,
  costSummaryColumnContent,
  datesColumnContent,
  assignmentColumnContent,
  dividerClassName,
}) => {
  return (
    <div className={className}>
      <FlexColumn className={style['address-column']}>{addressColumnContent}</FlexColumn>
      <FlexColumn className={style['cost-summary-column']}>{costSummaryColumnContent}</FlexColumn>
      <Divider className={classnames(style['shipment-details-column-divider'], dividerClassName)} orientation='vertical' />
      <FlexColumn className={style['dates-column']}>{datesColumnContent}</FlexColumn>
      <FlexColumn className={style['assignment-column']}>{assignmentColumnContent}</FlexColumn>
    </div>
  );
};

ShipmentDetailsGridLayout.propTypes = {
  className: PropTypes.string,
  addressColumnContent: PropTypes.node.isRequired,
  costSummaryColumnContent: PropTypes.node.isRequired,
  datesColumnContent: PropTypes.node.isRequired,
  assignmentColumnContent: PropTypes.node.isRequired,
  dividerClassName: PropTypes.string,
};
